export enum SchedulerDefaultViewEnum {
    Day = 1,
    Week = 2,
    Month = 3,
    Flow = 4,
    Timeline = 5,
    WorkWeek = 6
}
